import React, { forwardRef, useEffect, useImperativeHandle, useRef } from "react";

// Runs one of the original calculator engines directly in the app page (no
// iframe). Each mount gets a fresh host element owned by the engine, so React
// never touches its DOM. Exposes the same cpg* bridge the iframe exposed.
const EngineTool = forwardRef(function EngineTool({ markup, mount, className, testid, onSave }, ref) {
  const wrapRef = useRef(null);
  const bridgeRef = useRef(null);
  const saveRef = useRef(onSave);
  saveRef.current = onSave;

  useEffect(() => {
    const host = document.createElement("div");
    host.className = `${className} cpg-tool`;
    host.setAttribute("data-testid", testid);
    host.innerHTML = markup;
    wrapRef.current.appendChild(host);
    const bridge = mount(host, {
      post: (msg) => {
        if (msg?.__cpg === "save-draft" || msg?.__cpg === "save-result") saveRef.current?.(msg.__cpg);
      },
      scrollTop: () => host.scrollIntoView({ behavior: "smooth", block: "start" }),
    });
    bridgeRef.current = bridge;
    return () => { bridge.destroy(); bridgeRef.current = null; host.remove(); };
  }, [markup, mount, className, testid]);

  useImperativeHandle(ref, () => ({
    get cpgCollectState() { return bridgeRef.current?.cpgCollectState; },
    get cpgApplyState() { return bridgeRef.current?.cpgApplyState; },
    get cpgSetViewOnly() { return bridgeRef.current?.cpgSetViewOnly; },
  }), []);

  return <div ref={wrapRef} />;
});

export default EngineTool;
